import { Gondor } from "../Gondor";

const ACTIONS = {
  CARDS_ITEM: "/lead/{leadId}/card",
};

export function find(leadId: string) {
  return Gondor.http.get(ACTIONS.CARDS_ITEM.replace("{leadId}", leadId));
}
